/* eslint-disable import/no-default-export */
import ValidatedInput from './ValidatedInput';

export { ValidatedInput };
export default ValidatedInput;
